import React from "react";

export default function Button({ onClick, children, disabled }) {
  return (
    <button
      disabled={disabled}
      style={{
        padding: "10px 30px",
        marginTop: "15px",
        height: "45px",
        fontWeight: "bold",
        fontSize: "16px",
        borderRadius: "5px",
        borderWidth: "0px",
        backgroundColor: disabled ? "rgb(125, 175, 249)" : "#0067ff",
        cursor: "pointer",
        color: "white",
        textDecoration: "none",
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
